import { Helmet } from 'react-helmet-async';
// sections
import { TourGuideUserMapping } from 'src/sections/tourGuide/view';

// ----------------------------------------------------------------------

export default function TourGuideUserMappingPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Item Configure tour guide</title>
      </Helmet>

      <TourGuideUserMapping />
    </>
  );
}
